import React from 'react'

interface InfoIconProps {
  className?: string
  size?: number
  color?: string
}

export const InfoIcon: React.FC<InfoIconProps> = ({
  className,
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      role="img"
      className={className}
      style={{ color }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10ZM10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7ZM10 8C10.5523 8 11 8.44772 11 9V13.5833C11 14.1356 10.5523 14.5833 10 14.5833C9.44772 14.5833 9 14.1356 9 13.5833V9C9 8.44772 9.44772 8 10 8Z"
        fill="currentColor"
      />
    </svg>
  )
}